/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2018, Zumper
 * @description Refresh
 */

import React from 'react'

export interface RefreshIconProps {
  fill?: string
  size?: number
}

export const Refresh = ({ fill = '#FFF', size = 15 }: RefreshIconProps) => (
  <svg fill="none" height={size} viewBox={`0 0 ${size} ${size}`} width={size}>
    <path
      clipRule="evenodd"
      d="M1.47 6.327a4.857 4.857 0 1 1 6.072 4.704l.53-.632a.719.719 0 0 0-1.102-.924L5.892 10.76l-.603.718a.5.5 0 0 0 .062.705l.718.603 1.285 1.078a.719.719 0 0 0 .924-1.102l-.398-.334A6.295 6.295 0 1 0 .031 6.326a.719.719 0 1 0 1.438 0z"
      fill={fill}
      fillRule="evenodd"
    />
  </svg>
)
